module.exports = __webpack_public_path__ + "img/icon_cooler_logo.2e8420a3.png";